import { render, staticRenderFns } from "./side-menu-item.vue?vue&type=template&id=2c421a80"
import script from "./side-menu-item.vue?vue&type=script&lang=ts"
export * from "./side-menu-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports